module.exports = function() {
  return new Worker(__webpack_public_path__ + "21fe9a67f8b96844e9d7.worker.js");
};